import * as React from "react";
const SvgFiBrandsLinkedin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-linkedin_svg__a)">
      <path d="M23.96 21.584h.237l-.453-.658c.277 0 .424-.17.426-.376l-.001-.025c0-.282-.177-.417-.541-.417h-.587v1.476h.22v-.643h.272zm-.442-.81h-.257v-.5h.325c.168 0 .36.027.36.238 0 .242-.193.262-.428.262M18.012 19.073h-3.133v-4.71c0-1.122-.02-2.567-1.629-2.567-1.631 0-1.881 1.223-1.881 2.487v4.79H8.238V9.389h3.007v1.323h.042c.613-1.006 1.753-1.607 2.966-1.564 3.175 0 3.76 2.005 3.76 4.612zM4.703 8.065c-1.004 0-1.818-.781-1.818-1.745S3.7 4.575 4.703 4.575s1.818.78 1.818 1.745c0 .964-.814 1.745-1.818 1.745M6.27 19.073H3.133V9.389H6.27zm13.304-17.29H1.559C.71 1.773.01 2.429 0 3.246V20.61c.01.818.708 1.473 1.56 1.464h18.013c.853.01 1.554-.645 1.566-1.464V3.245c-.013-.82-.714-1.474-1.566-1.463" />
      <path d="M23.545 19.45c-.796.008-1.436.634-1.427 1.398.007.764.66 1.378 1.455 1.37.796-.007 1.435-.633 1.427-1.397-.007-.754-.643-1.363-1.427-1.37zm.033 2.609c-.698.01-1.306-.522-1.317-1.192-.012-.67.544-1.222 1.242-1.233s1.273.523 1.285 1.193v.02c.014.655-.527 1.198-1.21 1.212h-.032z" />
    </g>
    <defs>
      <clipPath id="fi-brands-linkedin_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsLinkedin;
